export default "__VITE_ASSET__DdTFDpPK__"